import React from 'react';
import { actions } from '@ecosystem/newron-design-system';
import { FEATURE_TAGS_STORAGE_KEY } from './utils';

const { Button } = actions;

type Props = {
  featureTag: string;
  tagOn: boolean;
  toggleFeatureTag: (featureTag: string) => void;
};

function FeatureToggleButton({ featureTag, tagOn, toggleFeatureTag }: Props) {
  const featureTags = localStorage.getItem(FEATURE_TAGS_STORAGE_KEY);

  return (
    <>
      {featureTags && (
        <div className={`flex fixed bottom-0 right-0 mb-2 mr-20 p-2 bg-white rounded`}>
          <Button onClick={() => toggleFeatureTag(featureTag)} mode={tagOn ? 'primary' : 'secondary'}>
            {featureTag}
          </Button>
        </div>
      )}
    </>
  );
}

export { FeatureToggleButton };
